export function usePaginatedArticles(categoryId: Ref<number | undefined>) {
  const route = useRoute()
  const router = useRouter()

  const pageNumber = computed(() => {
    const page = Number(route.query.page)
    return Number.isNaN(page) || page < 1 ? 1 : page
  })

  function onPageChange(newPage: number) {
    router.push({
      query: { ...route.query, page: newPage },
    })
  }

  const { data, pending, refresh, error } = useAsyncData(
    () => `articles-${categoryId.value}-${pageNumber.value}`,
    () =>
      $fetch('/api/articles/getArticlesByCategory', {
        method: 'GET',
        query: {
          categoryId: categoryId.value,
          pageNumber: pageNumber.value,
        },
      }),
  )

  return {
    data,
    pageNumber,
    onPageChange,
    pending,
    error,
    refresh,
  }
}
